module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/incorrect@1x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-paytable/incorrect@1x.png
// module id = 710
// module chunks = 0